import { render } from "./TabsNavigation.vue?vue&type=template&id=6d5ed384&scoped=true&ts=true"
import script from "./TabsNavigation.vue?vue&type=script&lang=ts"
export * from "./TabsNavigation.vue?vue&type=script&lang=ts"

import "./TabsNavigation.vue?vue&type=style&index=0&id=6d5ed384&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5ed384"]])

export default __exports__